import React, { Suspense } from "react";
import { Redirect, Switch } from "react-router-dom";
import { ContentRoute } from "../../../_metronic/layout/components/content/ContentRoute";
import ProductCategory from "../component/productCategory";
import ProductList from "../component/productList";
import ProductDetail from "../component/productsDetail/productDetail";
import ProductCategoryCard from "../component/productCategoryCard";
import Cart from "../component/cart/cart";
import CartCard from "../component/cart/cartCard";
import HistoryList from "../component/historyList/historyList";

export default function ProductConfigPage() {
  return (
    <Switch>
      {
        /* Redirect from eCommerce root URL to /customers */
        <Redirect
          exact={true}
          from="/products"
          to="/products/productCategory"
        />
      }

      <ContentRoute
        path="/products/productCategory"
        component={ProductCategory}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      <ContentRoute
        path="/products/productCategory1/productList"
        component={ProductList}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      <ContentRoute
        path="/products/productCategory1/productList1/ProductDetail"
        component={ProductDetail}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      <ContentRoute
        path="/products/productCategory1/productCategoryCard"
        component={ProductCategoryCard}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      <ContentRoute
        path="/products/cart"
        component={Cart}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      <ContentRoute
        path="/products/cartCard"
        component={CartCard}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      <ContentRoute
        path="/products/historyList"
        component={HistoryList}
        label={undefined}
        children={undefined}
        render={undefined}
      />
    </Switch>
  );
}
